import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import { OnboardingStyle } from '../onboarding/onboarding-style';
import { AuthHeader, ContentLayout, FormLayout } from '../../../global-styles/layout';
import { PHONE_CONTACT_NUMBER } from '../../../constants';
import { Heading2Text, Subhead02Text } from '../../../components/typography/typography';
import AlxButton from '../../../components/alx-components/button';
import { images } from '../../../assets/images/images';
import { InvalidDataStyles } from './invalid-style';

const InvalidData = () => {
  const { t } = useTranslation(['common', 'invalidData']);
  const navigate = useNavigate();
  return (
    <ContentLayout data-cy="invalid-data-page">
      <InvalidDataStyles>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                <Heading2Text as="h1" weight={600}>
                  {t('invalidData:invalid-title')}
                </Heading2Text>
              </div>
            </AuthHeader>
            <div className="invalid-img">
              <img src={images.cars} alt="" />
            </div>
            <div className="invalid-text m-24px">
              <Subhead02Text>{t('invalidData:invalid-text')}</Subhead02Text>
              <Trans t={t} i18nKey="invalidData:invalid-text-2">
                Para cualquier consulta, puede ponerse en contacto con nosotros en el número{' '}
              </Trans>
              <a href={`tel:${PHONE_CONTACT_NUMBER}`}>{PHONE_CONTACT_NUMBER}</a>.
            </div>
          </div>
          <FormLayout>
            <AlxButton onClick={() => navigate('/')} data-cy="login-submit">
              {t('invalidData:invalid-home-button')}
            </AlxButton>
          </FormLayout>
        </OnboardingStyle>
      </InvalidDataStyles>
    </ContentLayout>
  );
};

export default InvalidData;
